<template>
	<div class="section-form" :style="{ backgroundColor: data.form.bg, borderRadius: data.form.radius ? data.form.radius : 0 }">
		<h2>网上预约</h2>
		<div class="input-wrap">
			<label @click="$refs.name.focus()"><span>*</span>姓名</label>
			<input type="text" ref="name" v-model="name" />
		</div>
		<div class="input-wrap">
			<label @click="$refs.tel.focus()"><span>*</span>电话</label>
			<input type="text" ref="tel" v-model="tel" />
		</div>
		<button ref="btn" class="btn" :style="{ backgroundColor: data.form.btnColor, boxShadow: `inset 0px 3px 0px ${data.form.btnShadowInsetColor}, 0px 3px 0px ${data.form.btnShadowOutsetColor}, 0px 6px 5px rgba(0, 0, 0, 0.5)` }" @click.prevent="submit">立即提交</button>
	</div>
</template>

<script>
import { Notify, Toast } from 'vant';
import Qs from 'qs';
export default {
	props: ['dataP', 'dataSourceP'],
	data() {
		return {
			data: {
				form: {
					bg: '#e3d8d6',
					btnColor: '#b66957',
					btnShadowInsetColor: '#d38b7d',
					btnShadowOutsetColor: '#874434'
				}
			},
			color: '',
			name: '',
			tel: '',
			password: '3D3B48F64FF54052A1A259CB39538FF0',
			dataSource: '',
			clicking: false
		};
	},
	created() {
		this.data.form = Object.assign({}, this.data.form, this.dataP.form);
		this.dataSource = this.dataSourceP;
	},
	methods: {
		submit() {
			this.$refs.btn.style.backgroundColor = this.data.form.btnShadowOutsetColor;
			setTimeout(() => {
				this.$refs.btn.style.backgroundColor = this.data.form.btnColor;
			}, 100);

			console.log('click');
			if (this.name == '') {
				console.log('name is null');
				Notify({ type: 'danger', message: '姓名不能为空' });
			} else if (this.tel == '') {
				console.log('tel is null');
				Notify({ type: 'danger', message: '电话不能为空' });
			} else if (!/^1[3-9]\d{9}$/.test(this.tel)) {
				console.log('tel error');
				Notify({ type: 'danger', message: '请填写正确电话' });
			} else {
				if (!this.clicking) {
					this.clicking = true;
					console.log('fetch');
					this.postForm();
					if (this.$route.meta.pathname == 'zhihu') {
						this.$refs.btn.addEventListener('click', () => {
							window.zhad.push({
								eventtype: 'js_submit'
							});
						});
					}
				}
			}
		},
		postForm() {
			let data = {
				customerTel: this.tel,
				customerName: this.name,
				dataSource: this.dataSource
			};

			this.$axios.defaults.headers['timer'] = new Date().getTime();
			this.$axios.defaults.headers['customerTel'] = this.tel;
			this.$axios.defaults.headers['sign'] = this.$md5(new Date().getTime() + this.tel + this.password);
			console.log('fetch in');
			this.$axios({
				baseURL: process.env.VUE_APP_BASE_API,
				url: '/DataSourceCustomer/insertCustomer',
				method: 'POST',
				data: Qs.stringify(data)
			})
				.then((response) => {
					console.log(response);
					console.log('success');
					if (response.status == 200) {
						Toast.success({
							message: '预约成功',
							onClose: () => {
								this.clicking = false;
							}
						});
					} else {
						Toast.fail({
							message: '预约失败',
							onClose: () => {
								this.clicking = false;
							}
						});
					}
				})
				.catch((e) => {
					console.log('error');
					this.clicking = false;
				});
		}
	}
};
</script>

<style lang="scss" scoped>
.section-form {
	width: 88%;
	margin: 15px auto;
	padding: 20px;

	h2 {
		text-align: center;
		font-size: 1.6rem;
		color: inherit;
		margin-bottom: 20px;
	}

	.input-wrap {
		position: relative;
		margin-bottom: 12px;
		border: 1px solid #7d7d7d;
		border-radius: 8px;
		background-color: #fff;
	}

	label {
		position: absolute;
		left: 0;
		top: 0;
		line-height: 36px;
		margin-left: 8px;
		width: 70px;

		span {
			display: block;
			line-height: 46px;
			color: red;
			margin-right: 5px;
			float: left;
		}
	}

	input {
		box-sizing: border-box;
		width: 100%;
		height: 35px;
		padding: 0 8px 0 70px;
		outline: none;
		border: none;
		background-color: transparent;
	}

	.btn {
		display: block;
		width: 60%;
		margin: 20px auto 0;
		height: 40px;
		border: none;
		outline: none;
		border-radius: 50px;
		color: #fff;
		font-size: 1.2rem;
		cursor: pointer;
	}
}
</style>
